import moment from 'moment';

export const formatDate = (date: Date | string) => {
    return moment(date).format('YYYY-MM-HH:mm');
};

export const formatFullDate = (date: Date | string) => {
    return moment(date).format('[Le ] YYYY/MM/DD [à] HH[h]mm');
};

export const formatDay = (date: Date | string) => {
    if (!date) return '/';
    return moment(date).format('dddd DD MMMM YYYY');
};

export const formatHour = (date: Date | string) => {
    return moment(date).format('HH[h]mm');
};

export const formatEventPeriod = (startDate: Date | string, endDate: Date | string) => {
    const start = moment(startDate);
    const end = moment(endDate);

    // Vérifier si l'événement est sur plusieurs jours
    if (!start.isSame(end, 'day')) {
        // Format pour plusieurs jours: "De mardi 16 septembre 2025 9h00 à mercredi 17 septembre 2025 17h30"
        const startFormat = start.format('dddd DD MMMM YYYY HH[h]mm');
        const endFormat = end.format('dddd DD MMMM YYYY HH[h]mm');
        return `De ${startFormat} à ${endFormat}`;
    } else {
        // Format pour le même jour: "mardi 16 septembre 2025 de 09h00 à 17h30"
        const dayFormat = start.format('dddd DD MMMM YYYY');
        const startHour = start.format('HH[h]mm');
        const endHour = end.format('HH[h]mm');
        return `${dayFormat} de ${startHour} à ${endHour}`;
    }
};
